"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactDOMRender = void 0;
var React = require("react");
var client_1 = require("react-dom/client");
var ErrorHandlerComponent_1 = require("Views/Partials/Components/ErrorHandler/ErrorHandlerComponent");
var reactDOMRender = function (component, element) {
    var root = (0, client_1.createRoot)(element);
    root.render(React.createElement(ErrorHandlerComponent_1.ErrorHandlerComponent, null, component));
};
exports.reactDOMRender = reactDOMRender;
